import React from "react";
import { Route } from "react-router-dom";
//
import { URL } from "../url";
// component
import LayoutRoot from "../layout/layout_root";
import PrivateRoute from "../component/private_route";
//
import BailiffScreen from "screen/02_Bailiff/bailiff";
import BailiffDialog from "screen/03_Dialog/bailiff_dialog";
// import DevScreen from "screen/100_Dev/dev";
// import BusinessScreen from "screen/04_Business/business_screen";
//concept

const PERMISSION_SCREEN = "bailiff";

export const routerPrivate = () => {
  // -------------------------- STATE --------------------------

  // -------------------------- FUNCTION --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Route exact path={URL.list} element={<LayoutRoot />}>
      <Route
        index
        element={
          <PrivateRoute
            require={[PERMISSION_SCREEN]}
            element={<BailiffScreen />}
          />
        }
      />
      <Route
        path={URL.dialog}
        element={
          <PrivateRoute
            require={[PERMISSION_SCREEN]}
            element={<BailiffDialog />}
          />
        }
      />
    </Route>
  );
};
